import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Outlet } from 'react-router';
import Article from './Article';
import Articles from './Articles';
var BlogLayout = function () {
    return (_jsx(_Fragment, { children: _jsx(Outlet, {}) }));
};
var ArticleRoutes = [
    {
        path: 'learn',
        element: _jsx(BlogLayout, {}),
        children: [
            { index: true, element: _jsx(Articles, {}) },
            { path: 'category/:categorySlug', element: _jsx(Articles, {}) },
            { path: 'article/:articleSlug', element: _jsx(Article, {}) },
        ],
    },
];
export default ArticleRoutes;
